import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "custom-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "h4 text-primary" }, "Bulk Upload Employees", -1)
const _hoisted_3 = { class: "card mb-3 shadow-sm" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, " (files bundled as zip)", -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div><p> The template contains the following 10 columns, the minimum information we need to create an employee are first 3. If any of the first 3 are missing or if the work email is not a valid email then that employee record will be skipped. </p><ol><li>First name</li><li>Last name</li><li> Work email <span class=\"text-muted\">(Account setup email will be sent to this email)</span></li></ol><p> You can fill out the following extra fields also if you have the information available: </p><ol start=\"4\"><li> Gender <span class=\"text-muted\">(Accepted values: Male / Female / Prefer not to say)</span></li><li>Work/Office number</li><li>Home number</li><li>Mobile number</li><li>Personal email</li><li>Job title</li><li> Department name <span class=\"text-muted\">(If the department don&#39;t exist already we will create it.)</span></li></ol></div>", 1)
const _hoisted_10 = { class: "col-12 my-3" }
const _hoisted_11 = { class: "col-12 mt-3" }
const _hoisted_12 = { class: "row mb-5 mt-3" }
const _hoisted_13 = { class: "col-xs-12 col-sm-6 col-lg-4 col-xl-3 col-md-5 form-group" }
const _hoisted_14 = { class: "col-xs-12 col-sm-6 col-lg-4 col-xl-3 col-md-5 form-group" }
const _hoisted_15 = ["data-tooltip", "disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Upload ", -1)
const _hoisted_17 = { class: "spinner-border spinner-border-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_NotificationModal = _resolveComponent("NotificationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { crumbs: _ctx.crumbs }, null, 8, ["crumbs"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, null, {
        title: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, [
                _createTextVNode(" You can bulk add employees by either using an Excel (.xlsx / .xls) sheet or a comma-separated value(.csv) file. You can download blank "),
                _createElementVNode("a", {
                  href: _ctx.currentUrl,
                  class: "text-primary"
                }, "templates here", 8, _hoisted_7),
                _hoisted_8,
                _createTextVNode(" and fill them out with your employees data. ")
              ]),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("input", {
                type: "file",
                class: "",
                name: "uploadFile",
                ref: "uploadEmployee",
                accept: ".xlsx,.xls,.csv",
                onInput: _cache[0] || (_cache[0] = ($event: any) => ((_ctx.upload = true), (_ctx.isError = false), (_ctx.isUploaded = false)))
              }, null, 544),
              _createVNode(_component_ErrorMessage, {
                name: "uploadFile",
                class: "error-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.isUploaded)
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                    class: "alert alert-success mb-2"
                  }, [
                    _createTextVNode("Employees have been uploaded successfully, you can see the uploaded employees in Employee's page. But they must complete the sign up process by setting their passwords to log in to the system. You should also contact your employees to let them know that they will be receiving an automated email from the Workforce Kit system to complete the sign up. "),
                    _createVNode(_component_router_link, { to: { name: 'Employees' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("Click here to go to employees page.")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isError)
                ? (_openBlock(), _createElementBlock("label", {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                    class: "alert alert-danger mb-2"
                  }, "Something went wrong! Please try again"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                type: "button",
                isPrimary: true,
                class: "btn-secondary btn-lg-cus",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (this.$router.back()), ["prevent"]))
              }, " Cancel ")
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                "data-tooltip": !_ctx.upload ? 'Please select a file first' : null,
                disabled: !_ctx.upload || _ctx.loading,
                id: "uploadButton",
                class: "btn-primary btn-lg-cus",
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadEmployees && _ctx.uploadEmployees(...args)), ["prevent"]))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "mr-2",
                  icon: "upload"
                }),
                _hoisted_16,
                _withDirectives(_createElementVNode("span", _hoisted_17, null, 512), [
                  [_vShow, _ctx.loading]
                ])
              ], 8, _hoisted_15)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_NotificationModal, { ref: "notificationModal" }, null, 512)
  ], 64))
}